import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
import router from '../router';
import store from '../store';
import { getAccessToken } from './auth';
//import jsonwebtoken from 'jsonwebtoken';
// create an axios instance

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 180000, // request timeout
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'x-version': 1,
    'x-timestamp': new Date().valueOf(),
  },
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    
    if(!config.url.startsWith("/upi/dynamicqr")){
      store.dispatch('user/enableLoading');
    }
  
    //const accessToken = getAccessToken();
    // const refreshToken = getRefreshToken();

    config.headers['x-csrf-token'] = store.getters.csrfToken;
    //if (store.getters.accessToken && accessToken) {
      // if (config.url.includes('refresh') || config.url.includes('logout')) {
      //   config.headers.Authorization = `Bearer ${refreshToken}`;
      // } else {

      //config.headers.Authorization = `Bearer ${accessToken}`;
      // }
      config.headers['x-accountid'] = store.getters.accountIndex;
      return config;
    // eslint-disable-next-line no-else-return
    // } else {
    //   return config;
    // }

    // axios.get(`${process.env.VUE_APP_BASE_API}/getcsrftoken`).then((response) => {
    //   config.headers['X-CSRF-TOKEN'] = response.data.csrfToken;

    // }, (err) => {
    
    // });
  },
  (error) => {
    // do something with request error
    store.dispatch('user/disableLoading');
    
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const csrfToken = response.headers['x-csrf-token'];
    store.dispatch('user/setCsrfToken', csrfToken);
    store.dispatch('user/disableLoading');
    const res = response.data;

    if (res.code !== 200 && res.code !== 204 && response.status !== 200) {
      notify({
        title: 'Network error',
        message: '',
        type: 'error',
        duration: 5000,
      });
      return Promise.reject(new Error(res.message || 'Error'));
    }
    return res;
  },
  (error) => {
    store.dispatch('user/disableLoading');

    let message = '';
    if (error.response && error.response.data) {
      const errorRes = error.response.data;
      if (typeof error.response.data !== 'object') {
        message = error.response.data;
      } else if (errorRes.code === 500) {
        message = 'Server busy';
      } else if (errorRes.code === 400 || errorRes.code === 409 || errorRes.code === 429) {
        message = errorRes.message;
      } else if (errorRes.code === 403) {        
        //?message=Access Denied
        router.push('/error');
      } else if (errorRes.code === 401) {
        message = errorRes.message;
        if (!error.config.url.includes('/auth/login')) {
          store.dispatch('user/clearUserData').then(() => {
            router.push('/');
          });
        } else {
          message = errorRes.message;
        }
      } else {
        message = 'Network error';
      }
    }
    if (message) {
    
      notify({
        title: message.replace(/[\u00A0-\u9999<>\&]/g, ((i) => `&#${i.charCodeAt(0)};`)),
        message: '',
        type: 'error',
        duration: 8000,
      });
    }
    return Promise.reject(error);
  },
);

export default service;
